module.exports = __webpack_public_path__ + "static/img/weimg.4d9c9a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/weimg.jpg
// module id = q6yu
// module chunks = 15